module.exports = __webpack_public_path__ + "static/united-kingdom-e49055997b594435818d2d5412a1f9ca.jpeg";